import { render, staticRenderFns } from "./ListMenuItem.vue?vue&type=template&id=fb6473da&scoped=true"
import script from "./ListMenuItem.vue?vue&type=script&lang=js"
export * from "./ListMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ListMenuItem.vue?vue&type=style&index=0&id=fb6473da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6473da",
  null
  
)

export default component.exports